<div class="group-select-dialog">
  <h2 mat-dialog-title>Odaberi grupu i broj ležaljke</h2>
  <mat-dialog-content>
    <p class="dialog-subtitle">Odaberite grupu i unesite broj ležaljke:</p>

    <!-- Ležaljka info -->
    <div class="chair-info-panel" *ngIf="data.chair">
      <div class="chair-info-item">
        <mat-icon>event_seat</mat-icon>
        <span class="label">Tip:</span>
        <span class="value">{{ data.chair.type || 'Nepoznato' }}</span>
      </div>
<!--      <div class="chair-info-item">-->
<!--        <mat-icon>attach_money</mat-icon>-->
<!--        <span class="label">Cijena s popustom:</span>-->
<!--        <span class="value">{{ data.chair.priceWithDiscount }} EUR</span>-->
<!--      </div>-->
      <div class="chair-info-item">
        <mat-icon>attach_money</mat-icon>
        <span class="label">Cijena:</span>
        <span class="value">{{ data.chair.price }} EUR</span>
      </div>
    </div>

    <!-- Broj ležaljke input -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Broj ležaljke *</mat-label>
      <input
        matInput
        [(ngModel)]="chairNumber"
        placeholder="npr. 12"
        (keyup.enter)="canConfirm && confirm()"
      />
      <mat-icon matSuffix>numbered</mat-icon>
    </mat-form-field>

    <!-- Grupe -->
    <div class="groups-label">Odaberite grupu:</div>

      <div
        class="group-item"
        *ngFor="let group of data.groups"
        [class.selected]="selectedGroupId === group.id"
        (click)="selectGroup(group.id)"
      >
        <div class="group-info">
          <mat-icon class="group-icon">group</mat-icon>
          <div class="group-details">
            <div class="group-name">{{ group.name }}</div>
            <div class="group-meta">
              <span class="chair-count">
                <mat-icon>event_seat</mat-icon>
                {{ getGroupChairCount(group.id) }} ležaljki
              </span>
              <span class="budget">
                <mat-icon>attach_money</mat-icon>
                {{ group.price }} EUR
              </span>
            </div>
          </div>
        </div>
        <mat-icon class="check-icon" *ngIf="selectedGroupId === group.id">check_circle</mat-icon>
      </div>

    <div class="no-groups" *ngIf="data.groups.length === 0">
      <mat-icon>warning</mat-icon>
      <p>Nema dostupnih grupa. Kreirajte grupu prvo.</p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <div class="confirm-cancel-block">
      <button mat-button (click)="cancel()">Otkaži</button>
      <button
        mat-raised-button
        color="primary"
        [disabled]="!canConfirm || data.groups.length === 0"
        (click)="confirm()"
      >
        Dodijeli
      </button>
    </div>

  </mat-dialog-actions>
</div>
